import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';
import { extractLinks } from '@zonofi/common/functions/extract-links';

export const renderTextWithLinks = (
  text: string
): string | JSX.Element | JSX.Element[] => {
  const links = extractLinks(text);
  let messageText = DOMPurify.sanitize(text);
  if (links) {
    links.forEach((link) => {
      const anchorTag = `<a href="${link}" target="_blank">${link}</a>`;
      messageText = messageText.replace(link, anchorTag);
    });
  }
  return Parser(messageText);
};
